import { render } from "./Step1.vue?vue&type=template&id=04b6ef62&scoped=true&ts=true"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"

import "./Step1.vue?vue&type=style&index=0&id=04b6ef62&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b6ef62"]])

export default __exports__